<template>
<div class="chapter">
<div class="inner_page">
<h1>Texas Gamble</h1>
<h3 class="sigil_not_in_toc"><i>Texas Star Trilogy: Book One</i></h3>
<h3 class="sigil_not_in_toc">Vivian Vaughan</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02a_title.vue?e99032b2